import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import BasicTooltip from "src/components/BasicTooltip";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

import Context from "../../../../../context";

// ----------------------------------------------------------------------

type Props = {
	isOwners?: boolean;
};

export const NoTransfer = ({ isOwners }: Props) => {
	const { subproduct } = useContext(Context);
	const { translate } = useLocales();

	const title = isOwners
		? `No soportamos el transpaso de ${
				subproduct === "FUND" ? "fondos" : "planes"
		  } en lo que no coincidan los titulares de tu cuenta destino.`
		: "Este fondo no se puede traspasar.";
	const color = isOwners ? "text.primary" : "error.main";
	const text = isOwners ? "No soportado" : "No traspasable";

	return (
		<BasicTooltip title={translate(title)}>
			<Stack direction={"row"} alignItems={"center"} gap={0.8}>
				<Typography variant='subtitle1' fontSize={13} color={color}>
					{translate(text)}
				</Typography>

				<Iconify icon='lucide:info' width={14} color={color} />
			</Stack>
		</BasicTooltip>
	);
};

export default NoTransfer;
